import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { colors } from '../constants/colors';

interface LayoutProps {
  children: ReactNode;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
}

export function Layout({ children, searchQuery, onSearchChange }: LayoutProps) {
  return (
    <div style={styles.container}>
      <Header searchQuery={searchQuery} onSearchChange={onSearchChange} />
      <main style={styles.main}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    backgroundColor: colors.gray[100],
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
  },
};
